import { format, addDays, subDays, isAfter, isBefore, isEqual } from "date-fns";
import { DATE_FORMAT } from "../shared/constants";

export const formatDefaultDate = (date: string | Date): string => {
  const finalDate = typeof date === "string" ? new Date(date) : date;
  return format(finalDate, DATE_FORMAT.DEFAULT);
};

export const formatVisualDate = (date: string | Date): string => {
  const finalDate = typeof date === "string" ? new Date(date) : date;
  return format(finalDate, DATE_FORMAT.VISUAL);
};

export const addDaysToStringDate = (date: string, daysToAdd: number): string =>
  formatDefaultDate(addDays(new Date (date), daysToAdd));

export const subDaysToStringDate = (date: string, daysToSubstract: number): string =>
  formatDefaultDate(subDays(new Date(date), daysToSubstract));

export const isAfterDates = (start: string | Date, end: string | Date): boolean => {
  return isAfter(new Date(start), new Date(end));
};

export const isBeforeDates = (start: string | Date, end: string | Date): boolean => {
  return isBefore(new Date(start), new Date(end));
};

export const isEqualDates = (start: string | Date, end: string | Date): boolean => {
  return isEqual(new Date(start), new Date(end));
};

export const isBeforeOrEqualDates = (start: string | Date, end: string | Date): boolean => {
  return isBeforeDates(start, end) || isEqualDates(start, end);
};

export const isAfterOrEqualDates = (start: string | Date, end: string | Date): boolean => {
  return isAfterDates(start, end) || isEqualDates(start, end);
};
